/** Client helper for the /api/send-email proxy route (Nodemailer, SMTP from env). */
import { postApiJson } from './apiClient'

export interface EmailAttachment {
  filename: string
  content: string // base64
  contentType: string
}

export interface SendEmailParams {
  to: string
  /** Optional CC recipients (comma string or array). */
  cc?: string | string[]
  subject: string
  text?: string
  html?: string
  attachments?: EmailAttachment[]
}

export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const result = String(reader.result || '')
      resolve(result.split(',')[1] || '')
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

export async function sendEmail(params: SendEmailParams): Promise<void> {
  await postApiJson('/api/send-email', params)
}
